import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const ArrowRightDown18 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={18}
    contrast={contrast}
    className={className}
  >
    <path
      d='M14.25 13.1893L14.25 6L15.75 6L15.75 15.7501L6 15.7501L6 14.2501H13.1895L2.46973 3.53033L3.53039 2.46967L14.25 13.1893Z'
      fill='currentColor'
    />
  </Svg>
);

ArrowRightDown18.displayName = 'ArrowRightDown18';
export default ArrowRightDown18;
